var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "d-flex h-100 w-100" }, [
    _vm.isLoading
      ? _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-center align-items-center w-100"
          },
          [
            _c("div", {
              staticClass: "d-flex spinner-border text-dark",
              attrs: { role: "status" }
            })
          ]
        )
      : _c("div", { staticClass: "w-100" }, [
          _c("h3", { staticClass: "mt-3" }, [
            _vm._v(" " + _vm._s(_vm.formLabel) + " ")
          ]),
          _c("div", { staticClass: "alert alert-light" }, [
            _vm.isAnswered
              ? _c("div", { staticClass: "text-center" }, [
                  _c("h3", [
                    _vm._v("Merci d'avoir pris le temps de répondre !")
                  ]),
                  _c("p", { staticClass: "question-hint" }, [
                    _vm._v(" Vous pouvez fermer cette fenêtre. ")
                  ])
                ])
              : _c(
                  "div",
                  [
                    _c("h4", { staticClass: "question-label" }, [
                      _vm._v(
                        "Diriez-vous que vous êtes satisfait(e) de la solution Emotivi ?"
                      )
                    ]),
                    _c("p", { staticClass: "question-hint m-0" }, [
                      _vm._v(
                        "Donnez une note de 1 à 5 en cliquant sur une étoile."
                      )
                    ]),
                    _c("star-rating", {
                      attrs: { "max-stars": 5 },
                      on: { ratingData: _vm.updateRating },
                      model: {
                        value: _vm.userRating,
                        callback: function($$v) {
                          _vm.userRating = $$v
                        },
                        expression: "userRating"
                      }
                    }),
                    _c("div", { staticClass: "align-content-center" }, [
                      _vm._v(" " + _vm._s(_vm.ratingStatus) + " ")
                    ]),
                    _c("h4", { staticClass: "question-label mt-4" }, [
                      _vm._v("Recommanderiez-vous la solution Emotivi ?")
                    ]),
                    _c("p", { staticClass: "question-hint" }, [
                      _vm._v("Répondez par oui ou non.")
                    ]),
                    _c("div", { staticClass: "form-check form-check-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userRecommend,
                            expression: "userRecommend"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          name: "recommend",
                          type: "radio",
                          id: "reco_yes",
                          value: "1"
                        },
                        domProps: { checked: _vm._q(_vm.userRecommend, "1") },
                        on: {
                          change: function($event) {
                            _vm.userRecommend = "1"
                          }
                        }
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "reco_yes" }
                        },
                        [_vm._v("Oui")]
                      )
                    ]),
                    _c("div", { staticClass: "form-check form-check-inline" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userRecommend,
                            expression: "userRecommend"
                          }
                        ],
                        staticClass: "form-check-input",
                        attrs: {
                          name: "recommend",
                          type: "radio",
                          id: "reco_no",
                          value: "0"
                        },
                        domProps: { checked: _vm._q(_vm.userRecommend, "0") },
                        on: {
                          change: function($event) {
                            _vm.userRecommend = "0"
                          }
                        }
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label",
                          attrs: { for: "reco_no" }
                        },
                        [_vm._v("Non")]
                      )
                    ]),
                    _c("h4", { staticClass: "question-label mt-4" }, [
                      _vm._v("Souhaitez-vous témoignez de votre expérience ?")
                    ]),
                    _c("p", { staticClass: "question-hint" }, [
                      _vm._v(
                        "Décrivez en quelques mots ce qu'Emotivi a pu vous apporter."
                      )
                    ]),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userTestimony,
                          expression: "userTestimony"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { rows: "6" },
                      domProps: { value: _vm.userTestimony },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.userTestimony = $event.target.value
                        }
                      }
                    })
                  ],
                  1
                )
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isAnswered,
                  expression: "!isAnswered"
                }
              ],
              staticClass: "text-end mb-3"
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-large btn-primary",
                  on: { click: _vm.submitForm }
                },
                [_vm._v("Valider")]
              )
            ]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }